import moment from "moment";

const columns = [
  {
    title: "Deal",
    dataIndex: "deal",
  },
  {
    title: "Position Id",
    dataIndex: "positionID",
  },
  {
    title: "Order",
    dataIndex: "order",
  },
  {
    title: "Symbol",
    dataIndex: "symbol",
  },
  {
    title: "Volume",
    dataIndex: "volume",
  },
  {
    title: "Price",
    dataIndex: "price",
    render: (text) => {
      const value = typeof text === "number" ? text.toFixed(2) : "0.00";
      return `$ ${value}`;
    },
  },
  {
    title: "S/L",
    dataIndex: "priceSL",
    render: (text) => `$ ${text}`,
  },
  {
    title: "T/P",
    dataIndex: "priceTP",
    render: (text) => `$ ${text}`,
  },
  {
    title: "PNL",
    dataIndex: "profit",
    render: (text) =>
      text > 0 ? (
        <span className="text-[#28C76F] font-semibold">$ {text}</span>
      ) : (
        <span className="text-[#FF4C51] font-semibold">$ {text}</span>
      ),
  },
  {
    title: "Market Ask",
    dataIndex: "marketAsk",
    render: (text) => {
      const value = typeof text === "number" ? text.toFixed(2) : "0.00";
      return `$ ${value}`;
    },
  },
  {
    title: "Market Bid",
    dataIndex: "marketBid",
    render: (text) => {
      const value = typeof text === "number" ? text.toFixed(2) : "0.00";
      return `$ ${value}`;
    },
  },
  {
    title: "Profit Rate",
    dataIndex: "rateProfit",
    render: (text) => {
      const value = typeof text === "number" ? text.toFixed(2) : "0.00";
      return `$ ${value}`;
    },
  },
  {
    title: "Margin Rate",
    dataIndex: "rateMargin",
    render: (text) => {
      const value = typeof text === "number" ? text.toFixed(2) : "0.00";
      return `$ ${value}`;
    },
  },
  {
    title: "Close Time",
    dataIndex: "time",
    render: (text) => (text ? moment(text).format("DD-MM-YYYY h:mm A") : "--"),
  },
  {
    title: "Comment",
    dataIndex: "comment",
    render: (text) => (text === "" ? "--" : text),
  },
];

export default columns;
